import branditRails from '../../../../api/brandit_rails'
import { fetchBudgetManagementSystem } from '../slice.budgetManagement'
import { setShippingPaymentMethodAction, setThirdPartyBillingDataAction } from '../slice.checkoutRates'
import {
  clearStoreViewsAvailableAction,
  clearStoreViewsCurrentAction,
  clearStoreViewsErrorsAction,
  setStoreViewsCurrentAction,
  setStoreViewsErrorsAction,
  setStoreViewsStatusAction
} from './storeViews.actions'
import { getStoreViewPriority } from './storeViews.utils'
import { isPunchoutOnlyLocation } from '../../../../util/punchout'

const initializeShippingPaymentMethod = (dispatch, location) => {
  if (!location?.third_party_billing_enabled) return

  if (location.third_party_billing_default) {
    dispatch(setShippingPaymentMethodAction('third_party_billing'))
  }

  const carriers = location.third_party_billing_carriers || []
  if (carriers.length === 1) {
    dispatch(
      setThirdPartyBillingDataAction({
        carrierCode: carriers[0],
        accountNumber: '',
        zipCode: '',
        countryCode: 'US'
      })
    )
  }
}

export const fetchCurrentStoreView = storeViewId => async dispatch => {
  try {
    dispatch(setStoreViewsStatusAction('loading'))

    const { data } = await branditRails.get(`/locations/${storeViewId}`)

    dispatch(setStoreViewsCurrentAction(data))
    initializeShippingPaymentMethod(dispatch, data)
    dispatch(fetchBudgetManagementSystem(data.id))
    dispatch(setStoreViewsStatusAction('success'))
    return data
  } catch (err) {
    dispatch(setStoreViewsStatusAction('failed'))
    dispatch(
      setStoreViewsErrorsAction({
        action: 'fetchCurrentStoreView',
        message: err.message || err.response?.data?.message || 'Failed to fetch store view'
      })
    )
    return null
  }
}

export const initializeCurrentStoreView = portal => async (dispatch, getState) => {
  try {
    dispatch(setStoreViewsStatusAction('loading'))

    dispatch(clearStoreViewsErrorsAction())
    dispatch(clearStoreViewsAvailableAction())
    dispatch(clearStoreViewsCurrentAction())

    const { session } = getState()
    const localStorageLocation = localStorage.getItem('currentlocationId')
    const locationId = getStoreViewPriority(session, localStorageLocation, portal)

    if (!locationId) throw new Error('No valid location found')

    const { data: defaultLocation } = await branditRails.get(`/locations/${portal?.default_location?.id}`)
    const { data: preferredLocation } = await branditRails.get(`/locations/${locationId}`)
    const hasAuthenticatedSession = !!session?.rawToken
    const hasPunchoutSession = !!session?.punchout_buyer

    const isDedicatedPunchoutLocation = isPunchoutOnlyLocation(preferredLocation)
    const shouldFallbackToDefault =
      (!hasAuthenticatedSession && preferredLocation?.is_default !== true) ||
      (!hasPunchoutSession && isDedicatedPunchoutLocation)
    const currentLocation = shouldFallbackToDefault ? defaultLocation : preferredLocation

    dispatch(setStoreViewsCurrentAction(currentLocation))
    initializeShippingPaymentMethod(dispatch, currentLocation)
    dispatch(fetchBudgetManagementSystem(currentLocation.id))
    dispatch(setStoreViewsStatusAction('success'))
  } catch (err) {
    dispatch(setStoreViewsStatusAction('failed'))
    dispatch(
      setStoreViewsErrorsAction({
        action: 'initializeCurrentStoreView',
        message: err.message || err.response?.data?.message || 'Failed to fetch location'
      })
    )
  }
}
